<template>
  <div>
    <div class="docking">
      <div class="content-wrap">
        <div class="crumb">
          <span class="first_crumb" @click="toHome">首页</span>
          <span class="el-icon-arrow-right crumb_right"></span>
          <span class="second_crumb">快速对接流程</span>
        </div>
        <div class="docking_title">
          <div class="t_t">快速对接流程</div>
          <div class="t_t_border"></div>
          <div class="t_t_content">
            <div class="cricle_border">
              <div class="cricle"></div>
              <div class="brd_1"></div>
              <div class="b_cricle">
                <div class="r_cricle"></div>
              </div>
              <div class="brd_1_h"></div>
              <div class="c_cricle"></div>
              <div class="brd_1_h"></div>
              <div class="c_cricle"></div>
              <div class="brd_1_h"></div>
              <div class="c_cricle"></div>
            </div>
            <div class="cricle_title">
              <div :class="{cricle_item: index !== buList.length-1}" v-for="(item,index) in buList" :key="item.title">
                <div :class="{item_title: true, cr: index === 1, cg: index !== 0 && index !== 1}">{{item.title}}</div>
                <span :class="{item_co: true, cg: index !== 0 && index !== 1}">{{item.content}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="docking_content">
          <div class="t_t">快速对接</div>
          <div class="t_t_border"></div>
          <div class="dc_content">
            <div class="dc_ti">请您选择您想要对接的服务(多选)</div>
            <div class="dc_api">
              <div class="fs_14 dc_api_title">订单服务：</div>
              <el-checkbox-group v-model="checkedOrder" :style="{'--fill-color':'#E60000'}">
                <el-checkbox v-for="order in orderList" :label="order.value" :key="order.value" @>{{order.label}}</el-checkbox>
              </el-checkbox-group>
              <div class="fs_14 dc_api_title mat_15">物流轨迹：</div>
              <el-checkbox-group v-model="checkedLogistics" :style="{'--fill-color':'#E60000'}">
                <el-checkbox v-for="log in logisticsList" :label="log.value" :key="log.value">{{log.label}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="involve">
          <div class="t_t">涉及接口</div>
          <div class="t_t_border"></div>
          <div class="in_api">
            <div class="api_tag" v-for="item in checkedOrder.concat(checkedLogistics)" :key="item">{{apiList[item]}}<i class="el-tag__close el-icon-close cu_close" @click="removeApi(item)"></i></div>
          </div>
        </div>
        <div class="foot_tool">
          <div class="btn_cu btn_left mar_20" @click="goBack">返回</div>
          <div class="btn_cu btn_right" @click="addApi">添加到应用调试列表</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "../home/Footer.vue"
import { mapGetters } from 'vuex'
import { RESPONSE_SUCCESS } from '@/constants'
export default {
  name: 'Docking',
  components: { Footer },
  data() {
    return {
      buList: [
        { title: '步骤一', content: '注册并登录极兔快递开放平台' },
        { title: '步骤二', content: '[快速对接]添加需要对接的接口' },
        { title: '步骤三', content: '[控制台]完成认证并完成接口自助连调' },
        { title: '步骤四', content: '[应用管理]申请接口上线' },
        { title: '步骤五', content: '完成对接' }
      ],
      orderList: [
        { label: '下发订单到极兔', value: 1 },
        { label: '查询订单信息', value: 2 },
        { label: '取消订单', value: 3 },
        { label: '获取订单状态更新', value: 4 }
      ],
      logisticsList: [
        { label: '查询物流轨迹', value: 5 },
        { label: '物流轨迹订阅(开放平台下单客户无需对接此服务)', value: 6 },
        { label: '获取轨迹更新', value: 7 }
      ],
      apiList: { 1: '创建订单', 2: '查询订单', 3: '取消订单', 4: '订单状态回传', 5: '物流轨迹查询', 6: '物流轨迹订阅', 7: '物流轨迹回传' },
      checkedOrder: [],
      checkedLogistics: [],
      checkApi: [],
      apiSqlList: {
        1: '10000000011299',
        2: '10000000031299',
        3: '10000000021299',
        4: '10000001201299',
        5: '10000000001299',
        6: '10000000201299',
        7: '10000001101299'
      }
    }
  },
  computed: {
    ...mapGetters(['user', 'token', 'appId']),
  },
  mounted() {
    if (!this.token) this.$router.push({ name: 'Login' })
  },
  methods: {
    toHome() {
      this.$router.push('/')
    },
    removeApi(value) {
      this.checkedOrder = this.checkedOrder.filter(v => v !== value)
      this.checkedLogistics = this.checkedLogistics.filter(v => v !== value)
    },
    goBack() {
      window._hmt.push(['_trackCustomEvent', 'Docking_Back']);
      this.$router.go(-1)
    },
    async addApi() {
      window._hmt.push(['_trackCustomEvent', 'Docking_AddApi']);
      let idList = []
      this.checkedOrder.concat(this.checkedLogistics).forEach(v => {
        idList.push(this.apiSqlList[v])
      })
      if (!this.appId) {
        const res = await this.$API.appList()
        if (res.code === RESPONSE_SUCCESS) {
          if (!res.data[0].id) {
            return this.$message({ type: 'info', message: '请重新登录', duration: 1000 })
          }
          this.LOGIN_INIT_APPID({ appId: res.data[0].id })
        }
      }
      const { code, msg } = await this.$API.addInterface({ idList, appId: this.appId })
      if (code === RESPONSE_SUCCESS) {
        this.$message.success('添加成功')
        this.$router.push({ path: '/control/application' })
      } else {
        this.$message.error(msg)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.docking {
  font-size: 16px;
  min-height: calc(100% - 208px);
  background: #f2f2f2;
  padding-top: 64px;
  .content-wrap {
    position: relative;
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    .crumb {
      height: 21px;
      line-height: 21px;
      padding: 31px 0 20px;
      font-size: 14px;
      .first_crumb {
        color: #6A6A6A;
        cursor: pointer;
      }
      .crumb_right {
        color: #6A6A6A;
        margin: 0 3px;
      }
      .second_crumb {
        color: #2B2B2B;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 800;
      }
    }
    .docking_title {
      height: 214px;
    }
    .docking_title,
    .docking_content,
    .involve {
      border-radius: 6px;
      background: #ffffff;
      .t_t {
        color: #2B2B2B;
        font-size: 20px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 600;
        height: 28px;
        line-height: 28px;
        padding-top: 19px;
        margin-left: 24px;
        padding-bottom: 16.5px;
      }
      .t_t_border {
        border: 1px solid #f2f2f2;
      }
      .t_t_content {
        padding-top: 41.5px;
        margin-left: 24px;
        .cricle_border {
          display: flex;
          align-items: center;
          .cricle {
            height: 8px;
            width: 8px;
            border: 2px solid #E60000;
            border-radius: 50%;
            margin-right: 10px;
          }
          .brd_1 {
            width: 230px;
            height: 1px;
            background-color: #E60000;
            border-radius: 6px;
          }
          .b_cricle {
            width: 12px;
            height: 12px;
            margin: 0 10px;
            background: rgba(230,0,0,0.20);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            .r_cricle {
              width: 6px;
              height: 6px;
              background: #e60000;
              border-radius: 50%;
            }
          }
          .brd_1_h {
            width: 230px;
            height: 1px;
            background: #dddddd;
          }
          .c_cricle {
            width: 8px;
            height: 8px;
            border: 2px solid #dddddd;
            border-radius: 50%;
            margin: 0 10px;
          }
        }
        .cricle_title {
          display: flex;
          padding-top: 10px;
          .cricle_item {
            width: 260px;
            .item_title {
              color: rgba(0,0,0,0.90);
              font-size: 16px;
              margin-bottom: 5px;
            }
            .item_co {
              color: #2b2b2b;
              font-size: 14px;
            }
          }
        }
      }
    }
    .docking_content {
      height: 268px;
      margin-top: 10px;
      .dc_content {
        padding-top: 19.5px;
        margin-left: 20px;
        .dc_ti {
          font-size: 16px;
          font-weight: 600;
          height: 22px;
          line-height: 22px;
          color: #2B2B2B;
          border-left: 3px solid #E60000;
          padding-left: 10px;
        }
        .dc_api {
          padding-top: 30px;
          .dc_api_title {
            padding-bottom: 10px;
          }
        }
      }
    }
    .involve {
      min-height: 172px;
      margin-top: 10px;
      .in_api {
        padding-top: 20px;
        display: flex;
        margin-left: 24px;
        .api_tag {
          height: 36px;
          line-height: 36px;
          text-align: center;
          padding: 0 10px;
          border-radius: 6px;
          background: rgba(230,0,0,0.08);
          border: 1px solid rgba(230,0,0,0.30);
          font-size: 14px;
          color: #E60012;
          margin-right: 10px;
          .cu_close {
            margin-left: 5px;
            cursor: pointer;
          }
          .cu_close:hover {
            transform: scale(0.98);
            background: #E60012;
            border-radius: 50%;
            color: white;
          }
        }
      }
    }
    .foot_tool {
      padding: 40px 0;
      display: flex;
      justify-content: center;
      .btn_cu {
        width: 203px;
        height: 48px;
        line-height: 48px;
        border-radius: 6px;
        text-align: center;
        cursor: pointer;
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
      }
      .btn_left {
        border: 1px solid #979797;
      }
      .btn_right {
        background-color: #E60000;
        color: #FFFFFF;
        &:hover{
          background: #fff;
          color: #c31422;
        }
      }
      .btn_cu:active {
        transform: scale(0.98);
        box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
      }
    }
  }
}
.cr {
  color: #E60000 !important;
}
.cg {
  color: #DDDDDD !important;
}
.bgff {
  background: #ffffff;
}
.bd_6 {
  border-radius: 6px;
}
.fs_14 {
  font-size: 14px;
}
.mat_15 {
  margin-top: 15px;
}
.mar_20 {
  margin-right: 20px;
}
</style>
<style lang='scss' scoped>
 ::v-deep .el-checkbox {
       .el-checkbox__input.is-checked + .el-checkbox__label {
        color: var(--fill-color) !important;
       }

       .el-checkbox__input.is-checked .el-checkbox__inner,
       .el-checkbox__input.is-indeterminate .el-checkbox__inner {
         background-color: var(--fill-color) !important;
         border-color: var(--fill-color) !important
       }

       .el-checkbox__input.is-focus .el-checkbox__inner,
       .el-checkbox__inner:hover {
         border-color: var(--fill-color) !important;
       }
     }

</style>
